/**
 * Phase 86 Plan 86-03 — column legend, rebuilt on the Compost design's
 * 8-column grid. Imports `MY_TASK_ROW_GRID` from `MyTaskRow.tsx` so the
 * header can never drift from the rows — see `MyTaskRow.test.tsx:48`.
 *
 * Labels + typography per README "The table grid": bold 9px mono, wide
 * tracking, on the band tint with a bottom border. First (spine) and last
 * (action) cells stay empty, matching the handoff's header row exactly.
 *
 * Phase 86 Plan 86-06 — `viewportMode` keeps this header in lockstep with
 * `MyTaskRow`'s own responsive collapse (README "Responsive"): below the
 * wider breakpoint the CLIENT and LOGGED labels are dropped along with the
 * cells they head, using the SAME `MY_TASK_ROW_GRID_NARROW` template the
 * rows switch to — one shared template, never two. `MyTasksZonedList` does
 * not render this legend at all in `card` mode, since a stacked card list
 * has no shared column header to keep in sync.
 */
import { MY_TASK_ROW_GRID, MY_TASK_ROW_GRID_NARROW, type MyTasksViewportMode } from './MyTaskRow';

const COL_LABEL = 'font-mono text-[9px] font-bold uppercase tracking-[0.16em] text-ms-text-muted';

export interface MyTasksColumnLegendProps {
  viewportMode?: MyTasksViewportMode;
}

export function MyTasksColumnLegend({ viewportMode = 'wide' }: MyTasksColumnLegendProps) {
  const grid = viewportMode === 'narrow' ? MY_TASK_ROW_GRID_NARROW : MY_TASK_ROW_GRID;
  const showClientAndLogged = viewportMode !== 'narrow';

  return (
    <div
      data-testid="my-tasks-column-legend"
      className="grid items-center py-2 border-b border-ms-border bg-ms-surface-2 shrink-0"
      style={{ gridTemplateColumns: grid }}
    >
      <span />
      <span className={`${COL_LABEL} pl-3`}>Code</span>
      <span className={COL_LABEL}>Task</span>
      {showClientAndLogged && <span className={COL_LABEL}>Client</span>}
      <span className={COL_LABEL}>Rot · Last Touch</span>
      {showClientAndLogged && <span className={COL_LABEL}>Logged</span>}
      <span className={COL_LABEL}>Due</span>
      <span />
    </div>
  );
}
